module.exports = __webpack_public_path__ + "img/Differentiation-BRCA_10X_WTA.da136405.png";